import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20composition%20of%20diverse%20fashion%20products%20arranged%20artistically%20on%20warm%20sand%20colored%20linen%20surface%2C%20sneakers%20next%20to%20leather%20handbag%20beside%20folded%20denim%20and%20a%20watch%2C%20scattered%20dried%20botanicals%2C%20natural%20window%20light%20casting%20soft%20shadows%2C%20editorial%20lifestyle%20photography%20with%20organic%20arrangement%20and%20generous%20copy%20space%20in%20upper%20third&width=1800&height=900&seq=hero-main-v2-a7x9&orientation=landscape"
          alt="Hipobuy Spreadsheet product research composition with curated fashion items"
          title="Hipobuy Spreadsheet - Product Research Resource Hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl">
          {/* Trust Badges */}
          <div className="flex flex-wrap gap-3 md:gap-4 mb-8">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full text-sm text-background-50">
              <i className="ri-checkbox-circle-fill text-accent-300 text-sm"></i>
              Updated 2026 Database
            </span>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full text-sm text-background-50">
              <i className="ri-checkbox-circle-fill text-accent-300 text-sm"></i>
              Complete Buying Guides
            </span>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full text-sm text-background-50">
              <i className="ri-checkbox-circle-fill text-accent-300 text-sm"></i>
              Spreadsheet Comparison
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-background-50 leading-tight mb-6">
            The Ultimate
            <br />
            Hipobuy Spreadsheet
            <br />
            Resource Hub
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mb-10 leading-relaxed">
            Discover, compare, and research thousands of products with the latest <strong>Hipobuy Spreadsheet</strong> guides, 
            reviews, and expert shopping resources. Your complete destination for smarter product discovery in 2026.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              hipobuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-background-50 text-foreground-950 font-semibold text-base rounded-full hover:bg-background-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <Link
              to="/hipobuy-spreadsheet-guide"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-background-50/40 text-background-50 font-semibold text-base rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Beginner Guide
              <i className="ri-book-open-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}